export default __webpack_public_path__ + "static/media/no-record-dark.5cfeac2c.svg";